/* content file: replace all html between <> </> with actual content */

export const Technik = () => { 
  return (
  <>
  <p>
    <strong>GA-Lotse</strong> basiert auf modernen Technologien und einer offenen, modularen Softwarearchitektur. Als Open-Source-Lösung ist der Quellcode öffentlich zugänglich und kann eingesehen, genutzt und weiterentwickelt werden. So schafft GA-Lotse die Grundlage für eine transparente, anpassbare und gemeinschaftlich weiterentwickelbare Software für öffentliche Institutionen.
  </p>
  </>    
  )
}
